import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./Transactions.css";

const baseURL = process.env.REACT_APP_API_BASE_URL;
const API_KEY = process.env.REACT_APP_BROWSER_API_KEY;

const fmt = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(n);

const fmtNum = (n) => new Intl.NumberFormat("en-IN").format(n);

export default function Transactions() {
  const history = useHistory();
  const [transactions, setTransactions] = useState([]);
  const [meta, setMeta] = useState({ total: 0, page: 1, limit: 10 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);

  const fetchTransactions = async (p = 1) => {
    const vendorId = localStorage.getItem("vendorId");
    if (!vendorId) { history.replace("/"); return; }
    try {
      setLoading(true);
      setError(null);
      const res = await fetch(
        `${baseURL}/photographer/transactions?vendor_id=${encodeURIComponent(vendorId)}&page=${p}&limit=10`,
        { headers: { "x-api-key": API_KEY } }
      );
      if (!res.ok) throw new Error("Failed to fetch transactions");
      const data = await res.json();
      setTransactions(data.transactions || []);
      setMeta({ total: data.total || 0, page: data.page || p, limit: data.limit || 10 });
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchTransactions(page); }, [page]);

  const totalPages = Math.ceil(meta.total / meta.limit);

  return (
    <div className="txn-wrapper">
      <div className="txn-container">

        {/* Back */}
        <button className="txn-back-btn" onClick={() => history.goBack()}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          Back
        </button>

        {/* Header */}
        <div className="txn-header">
          <div>
            <h1 className="txn-title">Transaction History</h1>
            <p className="txn-subtitle">All your purchase records</p>
          </div>
          {!loading && meta.total > 0 && (
            <div className="txn-count-badge">{fmtNum(meta.total)} transaction{meta.total !== 1 ? "s" : ""}</div>
          )}
        </div>

        {/* Loading */}
        {loading && (
          <div className="txn-loader">
            <div className="txn-spinner" />
            <span>Loading transactions…</span>
          </div>
        )}

        {/* Error */}
        {error && !loading && (
          <div className="txn-error">
            <span>⚠️ {error}</span>
            <button onClick={() => fetchTransactions(page)}>Retry</button>
          </div>
        )}

        {/* Empty */}
        {!loading && !error && transactions.length === 0 && (
          <div className="txn-empty">
            <div className="txn-empty-icon">🧾</div>
            <h3>No transactions yet</h3>
            <p>Your purchase history will appear here.</p>
          </div>
        )}

        {/* Table */}
        {!loading && !error && transactions.length > 0 && (
          <>
            <div className="txn-table-wrap">
              <table className="txn-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Invoice No</th>
                    <th>Credits</th>
                    <th>Amount Paid</th>
                    <th>Date</th>
                    <th>Invoice</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((txn, idx) => (
                    <tr key={txn.razorpay_payment_id || idx}>
                      <td className="txn-td-num">{(meta.page - 1) * meta.limit + idx + 1}</td>
                      <td>
                        <span className="txn-booking-id">{txn.internal_booking_id}</span>
                      </td>
                      <td>
                        <span className="txn-credits">
                          <span className="txn-coin">🪙</span>
                          {fmtNum(txn.credit_count)}
                        </span>
                      </td>
                      <td>
                        <span className="txn-amount">{fmt(txn.total_amount)}</span>
                      </td>
                      <td>
                        <span className="txn-payment-id">{txn.updated_at.split("T")[0]}</span>
                      </td>
                      <td>
                        {txn.invoice_url ? (
                          <a
                            className="txn-invoice-btn"
                            href={txn.invoice_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                              <polyline points="7 10 12 15 17 10"/>
                              <line x1="12" y1="15" x2="12" y2="3"/>
                            </svg>
                            Invoice
                          </a>
                        ) : (
                          <span className="txn-no-invoice">—</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="txn-pagination">
                <button
                  className="txn-page-btn"
                  disabled={page === 1}
                  onClick={() => setPage((p) => p - 1)}
                >
                  ← Prev
                </button>
                <span className="txn-page-info">Page {page} of {totalPages}</span>
                <button
                  className="txn-page-btn"
                  disabled={page === totalPages}
                  onClick={() => setPage((p) => p + 1)}
                >
                  Next →
                </button>
              </div>
            )}
          </>
        )}

      </div>
    </div>
  );
}
